module.exports = __webpack_public_path__ + "img/cunuc.af8dc65b.svg";